var app = angular.module("leonardo");

var ManageAccountDialog = function($scope, $q, AccountUserService, CategoryRestService, AccountInvitationService,
                                   AuthDataService, FormErrorsService, PortfolioService, PropertyService) {

  $scope.alias = $scope.ngDialogData.alias;
  $scope.authDataService = AuthDataService;

  $scope.isNull = isNull;

  $scope.categories = angular.copy(CategoryRestService.getCollection());
  $scope.portfoliosAvailable = PortfolioService.getAvailableToAssign({disable_pagination:true});
  $scope.propertiesAvailable = PropertyService.getAvailableToAssign({disable_pagination:true});

  var promises = [$scope.portfoliosAvailable, $scope.propertiesAvailable];

  $q.all(promises).then(function () {
    angular.forEach($scope.portfoliosAvailable.$object.results, function (portfolio) {
      if (portfolio.available_for_invitation !== false )
        $scope.notEmpty = true;
    });
    angular.forEach($scope.propertiesAvailable.$object.results, function (property) {
      if (property.available_for_invitation !== false )
        $scope.notEmpty = true;
    });
    $scope.notEmpty = $scope.notEmpty ? $scope.notEmpty : false;
  });

  $scope.init = function() {
    $scope.accountUser = {
      management_account_user: AccountUserService.currentAccountUser ? AccountUserService.currentAccountUser.id : null,
      categories: [],
      portfolios: [],
      properties: []
    };
  };

  $scope.send = function() {
    $scope.Form.$setSubmitted();
    if ($scope.Form.$invalid) {
      FormErrorsService.goToError();
      return;
    }
    var accountUser = angular.copy($scope.accountUser);
    if (accountUser.properties_data){
      accountUser.portfolios = angular.copy(accountUser.properties_data.portfolios);
      accountUser.properties = angular.copy(accountUser.properties_data.properties);
      delete(accountUser.properties_data);
    }

    var data = {
      code: $scope.alias,
      management_info: accountUser,
      comment: $scope.comment
    };

    AccountInvitationService.post(data).then(function(result){
      AccountInvitationService.updateCollection(result);
      $scope.confirm();
    }, function(){
      $scope.closeThisDialog();
    });
  };

  $scope.init();
};

app.controller('ManageAccountDialog', ['$scope', '$q', 'AccountUserService', 'CategoryRestService',
  'AccountInvitationService', 'AuthDataService', 'FormErrorsService', 'PortfolioService', 'PropertyService',
  ManageAccountDialog]);
